module.exports = __webpack_public_path__ + "4188a12b4eb7fa282204313146ebdf6b.png";